export default __webpack_public_path__ + "static/media/Bar-Raval.2c0a6a9d.jpg";